import { render, staticRenderFns } from "./cartPage.vue?vue&type=template&id=718a3986&"
import script from "./cartPage.vue?vue&type=script&lang=js&"
export * from "./cartPage.vue?vue&type=script&lang=js&"
import style0 from "./cartPage.vue?vue&type=style&index=0&id=718a3986&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports